// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Feature;
(function (Feature) {
    Feature["UNSPECIFIED_FEATURE"] = "UNSPECIFIED_FEATURE";
    Feature["CUSTOM_CONTACTS"] = "CUSTOM_CONTACTS";
    Feature["INTEGRATED"] = "INTEGRATED";
    Feature["LIST_HOME_ICON"] = "LIST_HOME_ICON";
    Feature["BIRTHDAY_LISTS"] = "BIRTHDAY_LISTS";
    Feature["COLLECTIONS_LIST"] = "COLLECTIONS_LIST";
    Feature["FOLLOW_UPS_LIST"] = "FOLLOW_UPS_LIST";
    Feature["OVERDUE_PATIENTS_LIST"] = "OVERDUE_PATIENTS_LIST";
    Feature["RECOVERY_KIT"] = "RECOVERY_KIT";
    Feature["RESPONSE_KIT"] = "RESPONSE_KIT";
    Feature["WEAVE_VERIFY"] = "WEAVE_VERIFY";
    Feature["ANALYTICS_HOME_ICON"] = "ANALYTICS_HOME_ICON";
    Feature["ENTERPRISE_ANALYTICS"] = "ENTERPRISE_ANALYTICS";
    Feature["PRACTICE_ANALYTICS"] = "PRACTICE_ANALYTICS";
    Feature["CALL_REPORTS"] = "CALL_REPORTS";
    Feature["RECALL_REPORTS"] = "RECALL_REPORTS";
    Feature["PHONE_HOME_ICON"] = "PHONE_HOME_ICON";
    Feature["CLICK_TO_CALL"] = "CLICK_TO_CALL";
    Feature["ONLINE_SCHEDULING"] = "ONLINE_SCHEDULING";
    Feature["QUICKFILL"] = "QUICKFILL";
    Feature["SCHEDULE_EVENTS"] = "SCHEDULE_EVENTS";
    Feature["APPOINTMENT_WRITEBACKS"] = "APPOINTMENT_WRITEBACKS";
    Feature["APPT_CONFIRMATIONS_WRITEBACKS"] = "APPT_CONFIRMATIONS_WRITEBACKS";
    Feature["CHAT"] = "CHAT";
    Feature["FAX"] = "FAX";
    Feature["EMAIL"] = "EMAIL";
    Feature["TEXT_CONNECT"] = "TEXT_CONNECT";
    Feature["MASS_COMMUNICATIONS"] = "MASS_COMMUNICATIONS";
    Feature["VOICEMAIL_TRANSCRIPTION"] = "VOICEMAIL_TRANSCRIPTION";
    Feature["BULK_MESSAGING_500"] = "BULK_MESSAGING_500";
    Feature["BULK_MESSAGING_1000"] = "BULK_MESSAGING_1000";
    Feature["BULK_MESSAGING_1500"] = "BULK_MESSAGING_1500";
    Feature["BULK_MESSAGING_2000"] = "BULK_MESSAGING_2000";
    Feature["BULK_MESSAGING_3000"] = "BULK_MESSAGING_3000";
    Feature["BULK_MESSAGING_5000"] = "BULK_MESSAGING_5000";
    Feature["BULK_MESSAGING_10000"] = "BULK_MESSAGING_10000";
    Feature["BULK_MESSAGING_15000"] = "BULK_MESSAGING_15000";
    Feature["BULK_MESSAGING"] = "BULK_MESSAGING";
    Feature["AUTO_APPOINTMENT_REMINDER"] = "AUTO_APPOINTMENT_REMINDER";
    Feature["AUTO_BIRTHDAY_MESSAGE"] = "AUTO_BIRTHDAY_MESSAGE";
    Feature["AUTO_ORDER_READY_MESSAGE"] = "AUTO_ORDER_READY_MESSAGE";
    Feature["AUTO_MISSED_CALL_MESSAGE"] = "AUTO_MISSED_CALL_MESSAGE";
    Feature["AUTO_RECALL_REMINDER"] = "AUTO_RECALL_REMINDER";
    Feature["AUTO_MISSED_TEXT_MESSAGE"] = "AUTO_MISSED_TEXT_MESSAGE";
    Feature["AUTO_REACTIVATION_REMINDER"] = "AUTO_REACTIVATION_REMINDER";
    Feature["AUTO_REVIEW_REQUEST"] = "AUTO_REVIEW_REQUEST";
    Feature["REVIEWS_HOME_ICON"] = "REVIEWS_HOME_ICON";
    Feature["FORMS"] = "FORMS";
    Feature["PAYMENT_TERMINALS"] = "PAYMENT_TERMINALS";
    Feature["WEAVE_PAY"] = "WEAVE_PAY";
    Feature["CALL_INTELLIGENCE"] = "CALL_INTELLIGENCE";
    Feature["EMAIL_MARKETING"] = "EMAIL_MARKETING";
})(Feature || (Feature = {}));
export var Feature_index;
(function (Feature_index) {
    Feature_index[Feature_index["UNSPECIFIED_FEATURE"] = 0] = "UNSPECIFIED_FEATURE";
    Feature_index[Feature_index["CUSTOM_CONTACTS"] = 1] = "CUSTOM_CONTACTS";
    Feature_index[Feature_index["INTEGRATED"] = 2] = "INTEGRATED";
    Feature_index[Feature_index["LIST_HOME_ICON"] = 10] = "LIST_HOME_ICON";
    Feature_index[Feature_index["BIRTHDAY_LISTS"] = 11] = "BIRTHDAY_LISTS";
    Feature_index[Feature_index["COLLECTIONS_LIST"] = 12] = "COLLECTIONS_LIST";
    Feature_index[Feature_index["FOLLOW_UPS_LIST"] = 13] = "FOLLOW_UPS_LIST";
    Feature_index[Feature_index["OVERDUE_PATIENTS_LIST"] = 14] = "OVERDUE_PATIENTS_LIST";
    Feature_index[Feature_index["RECOVERY_KIT"] = 20] = "RECOVERY_KIT";
    Feature_index[Feature_index["RESPONSE_KIT"] = 21] = "RESPONSE_KIT";
    Feature_index[Feature_index["WEAVE_VERIFY"] = 30] = "WEAVE_VERIFY";
    Feature_index[Feature_index["ANALYTICS_HOME_ICON"] = 40] = "ANALYTICS_HOME_ICON";
    Feature_index[Feature_index["ENTERPRISE_ANALYTICS"] = 41] = "ENTERPRISE_ANALYTICS";
    Feature_index[Feature_index["PRACTICE_ANALYTICS"] = 42] = "PRACTICE_ANALYTICS";
    Feature_index[Feature_index["CALL_REPORTS"] = 50] = "CALL_REPORTS";
    Feature_index[Feature_index["RECALL_REPORTS"] = 51] = "RECALL_REPORTS";
    Feature_index[Feature_index["PHONE_HOME_ICON"] = 60] = "PHONE_HOME_ICON";
    Feature_index[Feature_index["CLICK_TO_CALL"] = 61] = "CLICK_TO_CALL";
    Feature_index[Feature_index["ONLINE_SCHEDULING"] = 70] = "ONLINE_SCHEDULING";
    Feature_index[Feature_index["QUICKFILL"] = 71] = "QUICKFILL";
    Feature_index[Feature_index["SCHEDULE_EVENTS"] = 72] = "SCHEDULE_EVENTS";
    Feature_index[Feature_index["APPOINTMENT_WRITEBACKS"] = 80] = "APPOINTMENT_WRITEBACKS";
    Feature_index[Feature_index["APPT_CONFIRMATIONS_WRITEBACKS"] = 81] = "APPT_CONFIRMATIONS_WRITEBACKS";
    Feature_index[Feature_index["CHAT"] = 90] = "CHAT";
    Feature_index[Feature_index["FAX"] = 91] = "FAX";
    Feature_index[Feature_index["EMAIL"] = 92] = "EMAIL";
    Feature_index[Feature_index["TEXT_CONNECT"] = 93] = "TEXT_CONNECT";
    Feature_index[Feature_index["MASS_COMMUNICATIONS"] = 94] = "MASS_COMMUNICATIONS";
    Feature_index[Feature_index["VOICEMAIL_TRANSCRIPTION"] = 95] = "VOICEMAIL_TRANSCRIPTION";
    Feature_index[Feature_index["BULK_MESSAGING_500"] = 100] = "BULK_MESSAGING_500";
    Feature_index[Feature_index["BULK_MESSAGING_1000"] = 101] = "BULK_MESSAGING_1000";
    Feature_index[Feature_index["BULK_MESSAGING_1500"] = 102] = "BULK_MESSAGING_1500";
    Feature_index[Feature_index["BULK_MESSAGING_2000"] = 103] = "BULK_MESSAGING_2000";
    Feature_index[Feature_index["BULK_MESSAGING_3000"] = 104] = "BULK_MESSAGING_3000";
    Feature_index[Feature_index["BULK_MESSAGING_5000"] = 105] = "BULK_MESSAGING_5000";
    Feature_index[Feature_index["BULK_MESSAGING_10000"] = 106] = "BULK_MESSAGING_10000";
    Feature_index[Feature_index["BULK_MESSAGING_15000"] = 107] = "BULK_MESSAGING_15000";
    Feature_index[Feature_index["BULK_MESSAGING"] = 108] = "BULK_MESSAGING";
    Feature_index[Feature_index["AUTO_APPOINTMENT_REMINDER"] = 110] = "AUTO_APPOINTMENT_REMINDER";
    Feature_index[Feature_index["AUTO_BIRTHDAY_MESSAGE"] = 111] = "AUTO_BIRTHDAY_MESSAGE";
    Feature_index[Feature_index["AUTO_ORDER_READY_MESSAGE"] = 112] = "AUTO_ORDER_READY_MESSAGE";
    Feature_index[Feature_index["AUTO_MISSED_CALL_MESSAGE"] = 113] = "AUTO_MISSED_CALL_MESSAGE";
    Feature_index[Feature_index["AUTO_RECALL_REMINDER"] = 114] = "AUTO_RECALL_REMINDER";
    Feature_index[Feature_index["AUTO_MISSED_TEXT_MESSAGE"] = 115] = "AUTO_MISSED_TEXT_MESSAGE";
    Feature_index[Feature_index["AUTO_REACTIVATION_REMINDER"] = 116] = "AUTO_REACTIVATION_REMINDER";
    Feature_index[Feature_index["AUTO_REVIEW_REQUEST"] = 117] = "AUTO_REVIEW_REQUEST";
    Feature_index[Feature_index["REVIEWS_HOME_ICON"] = 130] = "REVIEWS_HOME_ICON";
    Feature_index[Feature_index["FORMS"] = 140] = "FORMS";
    Feature_index[Feature_index["PAYMENT_TERMINALS"] = 150] = "PAYMENT_TERMINALS";
    Feature_index[Feature_index["WEAVE_PAY"] = 151] = "WEAVE_PAY";
    Feature_index[Feature_index["CALL_INTELLIGENCE"] = 160] = "CALL_INTELLIGENCE";
    Feature_index[Feature_index["EMAIL_MARKETING"] = 170] = "EMAIL_MARKETING";
})(Feature_index || (Feature_index = {}));
